import styled from 'styled-components';
import { grey40, white } from 'Styles/colors';

export const InformationCard = styled.div`
  border: 1px solid ${grey40};
  border-radius: 6px;
  background-color: ${white};
`;

export const Header = styled.div`
  padding: 12px;
`;

export const Divider = styled.div`
  width: 100%;
  border-top: 1px solid ${grey40};
  margin-bottom: 12px;
`;

export const Content = styled.div`
  padding: 0 12px 16px 12px;
`;
